import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { upperFirst } from 'lodash';
import { ProfileListItem } from '@vimily/bonjoro-ui-components-v2/ProfileListItem';

import { Profile } from '~/types/models';
import { useRelativeDate } from '~/react-hooks/use-date';
import { getProfileName } from '~/BonjorosList/util';
import { getTodoMultiName } from '~/BonjorosList/components/Todo/MultiName';

const IMAGE_MULTI_MAX = 3;

interface TodoImageManyProps {
  children: React.ReactNode;
}

function TodoImageMany({ children }: TodoImageManyProps) {
  return <div className='task-simple-image-container'>{children}</div>;
}

TodoImageMany.propTypes = {
  children: PropTypes.node.isRequired,
};

interface TodoSimpleProps {
  profiles: Profile[];
  onClick?: () => void;
  recordUrl?: string;
  reason?: string;
  simple?: boolean;
  className?: string;
  selected?: boolean;
  timestamp: string;
  icons?: React.ReactNode;
}

function TodoSimple({
  profiles,
  onClick,
  reason,
  selected,
  timestamp,
  icons,
}: TodoSimpleProps) {
  const relative = useRelativeDate(timestamp);
  const name = useMemo(() => {
    if (profiles.length === 1) {
      return getProfileName(profiles[0]);
    }

    return getTodoMultiName(profiles);
  }, [profiles]);

  const imgUrls = useMemo(
    () => profiles.slice(0, IMAGE_MULTI_MAX).map((profile) => profile.image),
    [profiles]
  );

  const subtitle = useMemo(() => {
    return (
      <div className='flex flex-col text-xs'>
        {profiles.length === 1 && (
          <span className='text-neutral-500 font-semibold'>
            {profiles[0].position}
          </span>
        )}
        {reason && <span className='text-black'>{reason}</span>}
      </div>
    );
  }, [reason, profiles]);

  return (
    <ProfileListItem
      className='!h-[80px]'
      name={name}
      subtitle={subtitle}
      imgUrl={imgUrls}
      active={selected}
      date={upperFirst(relative)}
      onClick={onClick}
      icons={icons}
      imgClassName='object-cover'
    />
  );
}

export default TodoSimple;
